import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home-data';

export default function GossipGrid() {
  const gridArticles = latestArticles.slice(3, 7);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950">
            最新大瓜
          </h2>
          <p className="mt-3 text-sm text-foreground-500">实时追踪 · 全网首发 · 爆料不停</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {gridArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="rounded-xl bg-background-100 overflow-hidden cursor-pointer group transition-all duration-300 hover:-translate-y-1"
            >
              {index === 0 && (
                <div className="absolute top-3 left-3 z-10">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-semibold rounded-md whitespace-nowrap">
                    HOT
                  </span>
                </div>
              )}
              <div className="p-3 md:p-4">
                <div className="aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="px-3 md:px-4 pb-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] md:text-xs text-primary-500 font-medium">{article.categoryName}</span>
                  {article.isNew && (
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-semibold rounded whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs" />
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/hot"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-950 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap group"
          >
            查看更多爆料
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
}